// extracted by mini-css-extract-plugin
module.exports = {"form":"UploadFromFB_form__2jrqA","redirectWarning":"UploadFromFB_redirectWarning__14iLe"};